/**
 * Custom error for OpenSearch service failures.
 * Thrown to trigger error boundary handling.
 */
export class OpenSearchDownError extends Error {
  readonly retryHref: string;

  constructor(retryHref: string) {
    super("OpenSearch service is unavailable");
    this.name = "OpenSearchDownError";
    this.retryHref = retryHref;
  }
}

/**
 * Type guard to check if an error is OpenSearchDownError
 */
export function isOpenSearchDownError(
  error: unknown,
): error is OpenSearchDownError {
  return error instanceof OpenSearchDownError;
}
